namespace Matrix.Data {
    export enum DataQueryType {
        StoredProc = 1,
        Table = 2,
        View = 3,
        SQL = 4,
        Workbook = 5
    }
    Serenity.Decorators.registerEnumType(DataQueryType, 'Matrix.Data.DataQueryType');
}
